<template>
    <div :id="'modal-quote-invoice-form-'+_uid" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static"
         data-keyboard="false"
         aria-labelledby="quoteInvoiceModal"
         aria-hidden="true"
         style="display: none;">

        <div class="modal-dialog max-width-700">
            <div class="modal-body full-height-scroll">
                <div v-if="selectedQuoteInvoice" class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title font-normal"
                            id="modalTitle">{{ mutableQuoteInvoice.type | titlecase }} Details - ({{ mutableQuoteInvoice.reference }})</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
                                @click.prevent="hideForm()">×
                        </button>
                    </div>

                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs profile-tab nav-fill">
                        <li class="nav-item">
                            <a class="nav-link p-2" @click.prevent="setActiveTab('details')" href="#"
                               :class="{'active' : activeTab==='details'}">
                                <i class="mdi mdi-information-outline" style="font-size: 20px;"></i>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link p-2" @click.prevent="setActiveTab('documents')" href="#"
                               :class="{'active' : activeTab==='documents'}">
                                <i class="mdi mdi-briefcase-outline" style="font-size: 20px;"></i>
                            </a>
                        </li>
                    </ul>

                    <!-- Tab panes -->

                    <div class="tab-content mt-3">
                        <div v-if="activeTab==='details'">
                            <div class="card-body limit-modal-height-80">
                                <form v-if="!showingItemForm" class="form with-elementio-elements">

                                    <!--Type & Status-->
                                    <div class="row">
                                        <div class="form-group col-sm-6">
                                            <label for="type">Select Type</label>
                                            <div id="type">
                                                <el-select v-model="form.type" class="w-100"
                                                           @change="updateQuoteInvoice"
                                                           placeholder="Quote / Invoice">
                                                    <el-option key="quote" label="Quote" value="quote"></el-option>
                                                    <el-option key="invoice" label="Invoice" value="invoice"></el-option>
                                                    <el-option key="pro-forma-invoice" label="Pro Forma Invoice" value="pro forma invoice"></el-option>
                                                </el-select>
                                            </div>
                                            <span class="invalid-feedback"
                                                  :class="{'d-block': form.errors.has('type')}"
                                                  v-show="form.errors.has('type')">
                                                {{ form.errors.get("type") }}
                                            </span>
                                        </div>

                                        <div class="form-group col-sm-6">
                                            <label for="type">Status</label>
                                            <div id="status">
                                                <el-select v-model="form.status" class="w-100"
                                                           @change="updateQuoteInvoice"
                                                           placeholder="Select Status">
                                                    <el-option key="draft" label="Draft" value="draft"></el-option>
                                                    <el-option key="final" label="Final" value="final"></el-option>
                                                    <el-option v-if="mutableQuoteInvoice.type==='quote'" key="notApproved" label="Not Approved"
                                                               value="not approved"></el-option>
                                                    <el-option v-if="['invoice', 'pro forma invoice'].includes(mutableQuoteInvoice.type)" key="billed"
                                                               label="Billed" value="billed"></el-option>
                                                    <el-option v-if="['invoice', 'pro forma invoice'].includes(mutableQuoteInvoice.type)" key="paid"
                                                               label="Paid" value="paid"></el-option>
                                                </el-select>
                                            </div>
                                            <span class="invalid-feedback"
                                                  :class="{'d-block': form.errors.has('status')}"
                                                  v-show="form.errors.has('status')">
                                                {{ form.errors.get("status") }}
                                            </span>
                                        </div>
                                    </div>

                                    <!--Contact-->
                                    <div class="row">
                                        <div class="form-group col-sm-12">
                                            <div class="col-md-12 p-0">
                                                <label style="display:inherit">Select Contact</label>

                                                <el-select
                                                    value-key="id"
                                                    class="w-100"
                                                    v-model="selectedContact"
                                                    @focus="searchContacts('')"
                                                    filterable
                                                    clearable
                                                    remote
                                                    :placeholder="'Search contact by Name / Email / Mobile'"
                                                    :remote-method="searchContacts"
                                                    :loading="loading">
                                                    <el-option
                                                        v-for="contact in suggestedContacts"
                                                        :key="contact.id"
                                                        :label="contact.full_name"
                                                        :value="contact">
                                                        <span class="position-relative">
                                                            <span v-if="contact.pivot"
                                                                  class="label label-light-primary mr-2">
                                                                {{ contact.pivot.role }}</span>
                                                            <span v-if="contact.juristic_name" class="mr-1">
                                                                {{ contact.juristic_name }} <span class="text-info">({{ contact.full_name }})</span></span>
                                                            <span v-else>{{ contact.full_name }}</span>
                                                        </span>
                                                    </el-option>
                                                </el-select>

                                                <span class="invalid-feedback"
                                                      :class="{'d-block': form.errors.has('contact_id')}"
                                                      v-show="form.errors.has('contact_id')">
                                                    {{ form.errors.get("contact_id") }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>


                                    <!--Date & Due Date-->
                                    <div class="row">
                                        <div class="form-group col-sm-6">
                                            <label for="date" class="mb-0">Date</label>
                                            <el-input
                                                @change="updateQuoteInvoice"
                                                id="date"
                                                class="mt-1"
                                                style="width: 100%;"
                                                placeholder="Please input"
                                                v-model="form.date"
                                                :disabled="true">
                                            </el-input>
                                        </div>

                                        <div class="form-group col-sm-6">
                                            <label for="due_date" class="mb-0">Due Date</label>
                                            <div id="due_date" class="row">
                                                <div class="col-sm-12 mt-1">
                                                    <el-date-picker
                                                        @change="inputChanged"
                                                        v-model="form.due_date"
                                                        type="date"
                                                        style="width: 100%;"
                                                        placeholder="Pick a day"
                                                        value-format="yyyy-MM-dd">
                                                    </el-date-picker>
                                                    <span class="invalid-feedback"
                                                          :class="{'d-block': form.errors.has('due_date')}"
                                                          v-show="form.errors.has('due_date')">
                                                        @{{ form.errors.get("due_date") }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div class="row">
                                        <div class="form-group col-sm-12 mt-2 mb-2">
                                            <el-switch
                                                v-model="shouldAutoCalculateVat"
                                                active-color="#13ce66"
                                                inactive-color="#CCC">
                                            </el-switch>
                                            <label style="display:inline; vertical-align: middle; padding-left: 5px">Auto Calculate VAT</label>
                                        </div>
                                    </div>


                                    <div class="form-group mt-6 mb-4">
                                        <div class="row font-medium">
                                            <div class="col-6">
                                                Items
                                            </div>
                                            <div class="col-2 text-right">
                                                Excl.
                                            </div>
                                            <div class="col-2 text-right">
                                                VAT
                                            </div>
                                            <div class="col-2 text-right">
                                                Total
                                            </div>
                                            <div class="col-1 text-right">
                                            </div>
                                        </div>

                                        <quote-invoice-line-item v-for="(lineItem, index) in lineItems"
                                                                 :key="lineItem.id"
                                                                 :line-item="lineItem"
                                                                 :class="{'even-row': index % 2}"
                                                                 :is-new-item="false"
                                                                 :auto-calculate-vat="shouldAutoCalculateVat"
                                                                 :company-vat-percentage="companyVatPercentage"
                                                                 :vat-calculation="vatCalculation"
                                                                 :quote-invoice="selectedQuoteInvoice"
                                                                 @line-item-deleted="removeItemFromList"
                                                                 @line-item-updated="replaceUpdatedItem"
                                        ></quote-invoice-line-item>

                                        <quote-invoice-line-item
                                            ref="newItemForm"
                                            :is-new-item="true"
                                            :auto-calculate-vat="shouldAutoCalculateVat"
                                            :company-vat-percentage="companyVatPercentage"
                                            :vat-calculation="vatCalculation"
                                            :quote-invoice="selectedQuoteInvoice"
                                            @new-line-added="insertNewItem"
                                        ></quote-invoice-line-item>

                                        <!--Totals & Terms-->
                                        <div class="row mt-6">
                                            <div class="col-8 col-md-9 font-medium text-right">
                                                Total Excl.
                                            </div>
                                            <div class="col-4 col-md-3 text-right">
                                                R {{ totalExcludingVat }}
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-8 col-md-9 font-medium text-right">
                                                Tax
                                            </div>
                                            <div class="col-4 col-md-3 text-right">
                                                R {{ totalVat }}
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-8 col-md-9 font-medium text-right">
                                                Total
                                            </div>
                                            <div class="col-4 col-md-3 text-right">
                                                R {{ invoiceTotal }}
                                            </div>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>

                        <div v-if="activeTab==='documents'">
                            <div class="card-body">
                                <document-list
                                    :document-list-url="documentsListUrl"
                                    :document-upload-url="documentUploadUrl"
                                    @start-loading-documents="loadingDocument=true"
                                    @finish-loading-documents="loadingDocument=false"
                                    @share-document="shareDocument">
                                </document-list>
                            </div>
                        </div>
                    </div>

                    <!--Buttons-->
                    <div>
                        <div class="modal-footer" style="border-top: 1px solid #ccc">
                            <div class="w-full flex justify-content-between">
                                <div class="flex justify-start items-center gap-x-2">
                                    <secondary-button v-if="activeTab==='details'"
                                                      @click.prevent="generateQuoteInvoiceDocument"
                                                      :disabled="compiling">
                                        <icon-document-outline class="h-5 w-5 mr-2 -ml-2"></icon-document-outline>
                                        <span> {{ (!compiling ? "Compile " + this.mutableQuoteInvoice.type : "Compiling Document...") | titlecase }}</span>
                                    </secondary-button>
                                    <button type="button"
                                            class="text-brand hover:text-red-500 font-medium ml-4"
                                            @click.prevent="deleteQuoteInvoice"
                                            :disabled="form.busy">{{ ("Delete " + this.mutableQuoteInvoice.type) | titlecase }}
                                    </button>
                                </div>
                                <div class="flex justify-end items-center gap-x-2">
                                    <button type="button"
                                            @click.prevent="hideForm()"
                                            :disabled="form.busy"
                                            class="inline-flex justify-center rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-indigo-300 focus:ring focus:ring-indigo-400 transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                                        Close
                                    </button>
                                    <secondary-button v-if="activeTab==='details'"
                                                      @click.prevent="updateQuoteInvoice"
                                                      :disabled="form.busy">
                                        Save
                                    </secondary-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import TabState from "../../mixins/tab-state";

export default {
    name: "quote-invoice",

    mixins: [TabState],

    props: ["contactable", "contactableId", "selectedQuoteInvoice", "companyVatPercentage", "vatCalculation", "autoCalculateVat"],

    data () {
        return {
            showingItemForm: false,
            mutableQuoteInvoice: {},
            lineItems: [],
            activeTab: "details",
            form: new AppForm(),
            compiling: false,
            loading: false,
            selectedContact: null,
            suggestedContacts: [],
            documentsListUrl: null,
            documentUploadUrl: null,
            shouldAutoCalculateVat: this.autoCalculateVat,
        };
    },

    watch: {
        "selectedQuoteInvoice": function (newValue) {
            this.lineItems = newValue.quote_invoice_line_items;
            this.mutableQuoteInvoice = this.selectedQuoteInvoice;
            this.documentsListUrl = "/quotes-invoices/" + this.selectedQuoteInvoice.id + "/documents";
            this.documentUploadUrl = "/quotes-invoices/" + this.selectedQuoteInvoice.id + "/documents/upload";
            this.selectedContact = newValue.contact;
            this.form = this.initInvoiceForm();
        },

        "autoCalculateVat": function (newValue) {
            this.shouldAutoCalculateVat = newValue;
        },

        "selectedContact": function () {
            this.form.contact_id = this.selectedContact ? this.selectedContact.id : null;
        }
    },

    computed: {
        totalExcludingVat () {
            let items = this.lineItems;

            let totalExcl = items.reduce((init, currentItem) => {
                return parseFloat(init) + parseFloat(currentItem.total_excl);
            }, 0);

            return totalExcl.toFixed(2);
        },

        totalVat () {
            let items = this.lineItems;
            let vat = items.reduce((init, currentItem) => {
                return parseFloat(init) + parseFloat(currentItem.vat);
            }, 0);

            return vat.toFixed(2);
        },

        invoiceTotal () {
            let items = this.lineItems;
            let total = items.reduce((init, currentItem) => {
                return parseFloat(init) + parseFloat(currentItem.total_incl);
            }, 0);

            return total.toFixed(2);
        },
    },

    methods: {
        setActiveTab (tab) {
            this.activeTab = tab;
        },

        showForm () {
            this.searchContacts();
            $("#modal-quote-invoice-form-" + this._uid).modal("show");
        },

        hideForm () {
            $("#modal-quote-invoice-form-" + this._uid).modal("hide");
            this.setActiveTab("details");
            if (this.$refs.newItemForm) {
                this.$refs.newItemForm.resetNewItemForm();
            }
        },

        inputChanged () {
            this.form.errors.forget();
        },

        initInvoiceForm () {
            return new AppForm({
                type: this.mutableQuoteInvoice.type,
                date: this.mutableQuoteInvoice.date,
                status: this.mutableQuoteInvoice.status,
                due_date: this.mutableQuoteInvoice.due_date,
                contact_id: this.mutableQuoteInvoice.contact ? this.mutableQuoteInvoice.contact.id : null,
            });
        },

        showItemEditForm () {
            this.showingItemForm = true;
        },

        queryIssues (queryString, cb) {
            let suggestions = this.issueSuggestions;
            let results = queryString ? suggestions.filter(this.createFilter(queryString)) : suggestions;
            // call callback function to return suggestions
            cb(results);
        },

        createFilter (queryString) {
            return (link) => {
                return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },

        insertNewItem (item) {
            this.lineItems.push(item);
        },

        removeItemFromList (itemId) {
            let index = this.lineItems.findIndex(item => item.id === itemId);
            this.lineItems.splice(index, 1);
        },

        replaceUpdatedItem (updatedItem) {
            let index = this.lineItems.findIndex(item => item.id === updatedItem.id);
            this.lineItems.splice(index, 1, updatedItem);
        },

        searchContacts (query) {
            axios.get("/quotes-invoices/get-contacts", {
                params: {
                    filter_text: query,
                    contactable: this.contactable,
                    contactable_id: this.contactableId,
                }
            }).then((response) => {
                this.suggestedContacts = response.data;
            }).catch(() => {
                toastr.error("Could not get contact suggestions!");
            });
        },

        updateQuoteInvoice () {
            App.patch("/quotes-invoices/" + this.mutableQuoteInvoice.id + "/update", this.form)
            .then((response) => {
                this.mutableQuoteInvoice = response;
                Bus.$emit("quote-invoice-updated", response);
                toastr.success(_.capitalize(this.mutableQuoteInvoice.type) + " updated!");
            }).catch((errors) => {
                toastr.error("Could not update " + this.form.type);
            });
        },

        deleteQuoteInvoice () {
            let self = this;
            swal({
                title: "Delete " + this.mutableQuoteInvoice.type,
                text: "Are you sure you want to completely delete this " + this.$options.filters.titlecase(self.mutableQuoteInvoice.type),
                showCancelButton: true
            }).then((result) => {
                if (result.value) {
                    App.delete("/quotes-invoices/" + self.mutableQuoteInvoice.id + "/delete", new AppForm({}))
                    .then((response) => {
                        $("#modal-quote-invoice-form-" + this._uid).modal("hide");
                        self.$emit("record-deleted", self.mutableQuoteInvoice.id);
                        toastr.success(this.mutableQuoteInvoice.type + " deleted!");
                    }).catch((errors) => {
                        toastr.error("Could not delete " + this.mutableQuoteInvoice.type);
                    });
                }
            });
        },

        generateQuoteInvoiceDocument () {
            if (this.form.contact_id === null) {
                toastr.error("You need to select a contact in order to make out a quote or invoice.");
                return;
            } else if (this.mutableQuoteInvoice.contact_id === null) {
                toastr.error("You need to save the contact to the quote or invoice before generating a report");
                return;
            }

            this.compiling = true;
            App.post("/quotes-invoices/" + this.mutableQuoteInvoice.id + "/documents/generate", new AppForm({}))
            .then(response => {
                toastr.success(this.mutableQuoteInvoice.type + " compiled!");
                this.setActiveTab("documents");
                this.compiling = false;
                window.open(response.url, "_blank");
                Bus.$emit("quote-invoice-document-generated", response);
            })
            .catch((errors) => {
                this.compiling = false;
                toastr.error("Error generating report!");
            });
        },

        shareDocument (document) {
            this.hideForm();
            Bus.$emit("share-document-with-selected-contact", document, this.mutableQuoteInvoice.contact_id);
        }
    }
};
</script>